import React from 'react'
import SVGIcon from '../helpers/icons'

function TipContentText (props) {
  return (
    <div className={'tip-modal-content text'}>
      <h2>{props.settings.title}</h2>
      <div className={'content'} dangerouslySetInnerHTML={{ __html: props.settings.content }}></div>
      <button onClick={props.closemodal} className={'button primary'}>{props.settings.close_button}</button>
      <button onClick={props.closemodal} aria-label={props.settings.close_button} className={'close-button'}>
        <SVGIcon type={'close'} fill={'#FFF'} className={'close-button__icon'}/>
      </button>
    </div>
  )
}

export default TipContentText